import React from 'react';
import Select, { Option } from 'rc-select';
import './style.css';

const DropdownField = ({
  input,
  label,
  options,
  placeholder,
  disabled,
  defaultValue,
}) => {
  const hasStatus = null;
  const message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  // if ( touched && error ) {
  // if (error) {
  //   hasStatus = 'danger';
  //   message = error;
  // } else if (warning) {
  //   // else if ( touched && warning ) {
  //   hasStatus = 'warning';
  //   message = warning;
  // } else if (touched) {
  //   hasStatus = 'success';
  //   message = null;
  // } else {
  //   hasStatus = null;
  //   message = null;
  // }

  // HACK for this: https://github.com/react-component/select/issues/287
  var inputValue = input.value === '' ? undefined : input.value;
  return (
    <div className={`dropdown-field form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      {label && (
        <label className="pr-0" htmlFor={input.name}>
          {label}
        </label>
      )}
      <Select
        {...input}
        value={inputValue || defaultValue}
        className="form-control form-control-danger form-control-warning form-control-success py-0 pr-0"
        dropdownClassName="rc-select-dropdown-field-dropdown"
        style={{ width: '100%' }}
        animation="slide-up"
        showSearch
        placeholder={placeholder}
        disabled={disabled}
        optionLabelProp="children"
        optionFilterProp="text"
      >
        {options.map((option, index) => (
          <Option key={index} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </Select>
      {message ? <div className="form-control-feedback"> {message} </div> : ''}
    </div>
  );
};

export default DropdownField;



// WEBPACK FOOTER //
// ./src/components/DropdownField/index.js